export const tabsName = {
  general: 1,
  image: 2,
  detail: 3,
};

export const viewerConfig = {
  viewerWidth: 932,
  viewerHeight: "1165px",
  backgroundMaxWidth: 800,
  watermarkMaxWidth: 600,
  logoMaxWidth: 220,
  qrCodeMaxWidth: 110,
};

export const fontFamilies = ["Times New Roman", "Calibri", "Arial"];

export const fontSizes = [
  { value: "10px", label: "10" },
  { value: "11px", label: "11" },
  { value: "12px", label: "12" },
  { value: "13px", label: "13" },
  { value: "14px", label: "14" },
  { value: "15px", label: "15" },
  { value: "16px", label: "16" },
  { value: "17px", label: "17" },
  { value: "18px", label: "18" },
  { value: "19px", label: "19" },
  { value: "20px", label: "20" },
  { value: "21px", label: "21" },
  { value: "22px", label: "22" },
  { value: "23px", label: "23" },
  { value: "24px", label: "24" },
  { value: "25px", label: "25" },
];

export const lineHeightOptions = [
  { value: "1", label: "1.0" },
  { value: "1.5", label: "1.5" },
  { value: "2", label: "2.0" },
];

export const letterSpacingOptions = [
  { value: "-0.5px", label: "-0.5" },
  { value: "0px", label: "0" },
  { value: "0.5px", label: "0.5" },
  { value: "1px", label: "1" },
  { value: "1.5px", label: "1.5" },
  { value: "2px", label: "2" },
  { value: "3px", label: "3" },
];

export const RootInvoiceTemplate = "root";
export const NormalInvoiceTemplate = "normal";
export const invoiceTypes = [
  {
    value: "1",
    label: "Hóa đơn giá trị gia tăng",
    serialNoPrefix: "C21T",
  },
  {
    value: "2",
    label: "Hóa đơn bán hàng",
    serialNoPrefix: "C22T",
  },
  {
    value: "5",
    label: "Phiếu xuất kho kiêm vận chuyển hàng hóa nội bộ",
    serialNoPrefix: "C23T",
  },
  {
    value: "6",
    label: "Phiếu xuất kho gửi bán hàng đại lý",
    serialNoPrefix: "C24T",
  },
];

export const invoiceTemplateStatus = {
  NEW: "M",
  USED: "P",
  ACTIVE: "O",
  INACTIVE: "C"
};

export const availableCharacters = [
  "a",
  "A",
  "b",
  "B",
  "c",
  "C",
  "d",
  "D",
  "e",
  "E",
  "g",
  "G",
  "h",
  "H",
  "k",
  "K",
  "l",
  "L",
  "m",
  "M",
  "n",
  "N",
  "p",
  "P",
  "q",
  "Q",
  "r",
  "R",
  "s",
  "S",
  "t",
  "T",
  "u",
  "U",
  "v",
  "V",
  "x",
  "X",
  "y",
  "Y",
];
